import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import MainPage from "./pages/MainPage/MainPage";
import OwnUserPage from "./pages/UserPage/OwnUserPage";
import HomePage from "./pages/HomePage";
import Homes from "./pages/Homes";
import UserHome from "./pages/UserHome";
import FAQMain from "./pages/FAQMain/FAQMain";
import theme from "./styles/mainstyle";
import { CssBaseline, ThemeProvider } from "@mui/material";
import TermsAndConditions from "./pages/TermsAndConditions";
import Articles from "./pages/Articles";
import ArticlePage from "./pages/Article";
import UserPage from "./pages/UserPage/UserPage";
import PressReleases from "./pages/PressReleases";
import PressRelease from "./pages/Pressrelease";
import AnalyticsConsentManager from "src/components/privacy/AnalyticsConsentManager";
import {
  capturePostHogPageView,
  initializePostHogIfConsented,
} from "./analytics/posthog";

let lastTrackedPagePath = "";

function PostHogPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedPagePath === currentPath) {
      return;
    }

    initializePostHogIfConsented();
    const didCapture = capturePostHogPageView(window.location.href);
    if (didCapture) {
      lastTrackedPagePath = currentPath;
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AnalyticsConsentManager />
        <PostHogPageViewTracker />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/faq" element={<FAQMain />} />
          <Route path="/homepage" element={<HomePage />} />
          <Route path="/homes" element={<Homes />} />
          <Route path="/users/:id" element={<UserPage />} />
          <Route path="/homes/:id" element={<UserHome />} />
          <Route path="/mypage" element={<OwnUserPage />} />
          <Route path="/terms-and-condition" element={<TermsAndConditions />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/press-releases" element={<PressReleases />} />
          <Route path="/press-releases/:slug" element={<PressRelease />} />
        </Routes>
      </Router>
      <CssBaseline />
    </ThemeProvider>
  );
}
